import React from "react";
import { FileSpecificationsContainer } from "../../../containers";

const FileSpecifications = (props) => {
  return <FileSpecificationsContainer {...props} />;
};

export default FileSpecifications;
